import { useState, useRef, useEffect } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { FaHome, FaTimes, FaYoutube, FaFacebook, FaArrowRight, FaAppStore } from 'react-icons/fa';
import { SiGoogleplay, SiApple } from 'react-icons/si';
import { GrAppsRounded } from "react-icons/gr";
import { getChannels } from '../api/publicApi';
import useFetch from '../hooks/useFetch';

const NAV_ITEMS = [
  { to: '/representations', label: 'NOS REPRÉSENTATION DANS LE MONDE' },
  { to: '/semence', label: 'LA SEMENCE MATINALE' },
  { to: '/motivation', label: 'LES LUNDIS DE LA MOTIVATION' },
  { to: '/evenements', label: 'NOS ÈVÉNEMENTS' },
  { to: '/directs', label: 'NOS DIRECTS' },
  { to: '/enseignements', label: 'NOS ENSEIGNEMENTS' },
  { to: '/prieres', label: 'PRIÈRES' },
  { to: '/temoignages', label: 'TÉMOIGNAGES' },
  { to: '/canaux', label: 'NOS CANAUX DE COMMUNICATION' },
  { to: '/contact', label: 'NOUS CONTACTER' },
];

const PAGE_TITLES = {
  '/': 'QUI SOMMES-NOUS ?',
  '/representations': 'NOS REPRÉSENTATION DANS LE MONDE',
  '/semence': 'LA SEMENCE MATINALE',
  '/motivation': 'LES LUNDIS DE LA MOTIVATION',
  '/evenements': 'NOS ÈVÉNEMENTS',
  '/directs': 'NOS DIRECTS',
  '/enseignements': 'NOS ENSEIGNEMENTS',
  '/prieres': 'PRIÈRES',
  '/temoignages': 'TÉMOIGNAGES',
  '/canaux': 'NOS CANAUX DE COMMUNICATION',
  '/contact': 'NOUS CONTACTER',
};

export default function UserLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const pageTitle = PAGE_TITLES[pathname]
    || (pathname.startsWith('/evenements/') ? 'DÉTAIL ÉVÉNEMENT' : '')
    || (pathname.startsWith('/pages/') ? 'INFORMATIONS' : '');
  const isHome = pathname === '/';
  const menuRef = useRef(null);
  const fabRef = useRef(null);

  const { data: channelsData } = useFetch(getChannels, { limit: 20, statut: 'active' }, []);
  const channels = channelsData?.data || [];

  useEffect(() => {
    const handleClick = (e) => {
      if (menuOpen && !menuRef.current?.contains(e.target) && !fabRef.current?.contains(e.target))
        setMenuOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [menuOpen]);

  return (
    <div className={`user-layout ${pageTitle ? 'has-page-title' : ''}`}>
      <div className="sticky-header">
        {/* Desktop topbar */}
        <header className="user-topbar desktop-topbar">
          <a className="topbar-home-link" href="/" onClick={e => { e.preventDefault(); navigate('/'); }}>
            <FaHome size={20} />
            <span>ACCUEIL</span>
          </a>
          <a className="brand" href="/" onClick={e => { e.preventDefault(); navigate('/'); }}>
            <img src="/logo182.png" alt="MCM" />
            <span>MINISTÈRE CATHOLIQUE MISERICORDE</span>
          </a>
          <div style={{ width: 60 }} />
        </header>

        {/* Mobile topbar */}
        <header className="mobile-topbar">
          {!isHome ? (
            <button className="mobile-back-btn" onClick={() => navigate(-1)}>
              <FaArrowRight style={{ transform: 'rotate(180deg)' }} size={16} />
            </button>
          ) : (
            <div style={{ width: 36 }} />
          )}
          <span className="mobile-topbar-title">{pageTitle || 'MCM'}</span>
          {!isHome && (
            <div style={{ width: 36 }} >
              <a className="topbar-home-link" href="/" onClick={e => { e.preventDefault(); navigate('/'); }}>
                <FaHome size={20} />
                <span>ACCUEIL</span>
              </a>
            </div>
          )}
          {isHome && <div style={{ width: 36 }} />}
        </header>

        {/* Desktop page title */}
        {pageTitle && (
          <div className="layout-page-title-bar d-md-block d-none">
            <h1 className="layout-page-title mb-0">{pageTitle}</h1>
            <div className="page-title-divider">
              <span className="page-title-line" />
              <span className="page-title-diamond">✦</span>
              <span className="page-title-line" />
            </div>
          </div>
        )}

        {/* Desktop nav */}
        <nav className="user-nav  hide-scrollbar d-flex desktop-only">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => (isActive ? 'active' : '')}
              style={{
                flex: 1,
                textWrap: 'nowrap',
                whiteSpace: 'pre-line',
                lineHeight: 1.3,
                textAlign: 'center',
                border: '1px solid #cccccc65',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <main className="user-content">
        <Outlet />
      </main>

      <footer className="user-footer">
        <span>© {new Date().getFullYear()} Ministère Catholique Miséricorde — MCM. Tous droits réservés.</span>
        
        <div className="footer-social">
          <span style={{ fontSize: 12, fontWeight: 600 }}>NOUS SUIVRE:</span>
          <a href={'https://www.youtube.com/@BergerElyseeDossaenprier-pe4re'} target="_blank" rel="noreferrer" title="YouTube"><FaYoutube color='#8b1512'/></a>
          <a href={'https://www.facebook.com/MCMisericorde'} target="_blank" rel="noreferrer" title="Facebook"><FaFacebook color='#8b1512'/></a>
          {/* <a 
            href="https://play.google.com/store/apps/details?id=com.ministeremc" 
            target="_blank" 
            rel="noreferrer"
            title="Google Play Store"
          >
            <SiGoogleplay color='#8b1512' size={18}/>
          </a> */}
          <a 
            href="https://apps.apple.com/us/app/minist%C3%A8re-catho-mis%C3%A9ricorde/id6801453231" 
            target="_blank" 
            rel="noreferrer"
            title="Apple App Store"
          >
            <FaAppStore color='#8b1512' size={18}/>
          </a>
        </div>
      </footer>

      {/* Floating menu button */}
      <button ref={fabRef} className={`fab-menu-btn${menuOpen ? ' open' : ''}`} onClick={() => setMenuOpen(o => !o)}>
        {menuOpen ? <FaTimes size={20} /> : <GrAppsRounded size={20} />}
      </button>

      {/* Floating menu panel */}
      {menuOpen && (
        <div ref={menuRef} className="fab-menu-panel">
          <NavLink to="/qui-sommes-nous" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setMenuOpen(false)}>
            QUI SOMMES NOUS ?
          </NavLink>
          {NAV_ITEMS.map(item => (
            <NavLink key={item.to} to={item.to}
              className={({ isActive }) => isActive ? 'active' : ''}
              onClick={() => setMenuOpen(false)}>
              {item.label}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
}
